import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [ 'template' ];
  declare readonly templateTarget: HTMLTemplateElement;

  connect() {
  }

  // https://stackoverflow.com/questions/71713303/rails-7-dynamic-nested-forms-with-hotwire-turbo-frames
  // __CHILD_INDEX__ will be replaced when creating an object
  // if using the id field in dynamic_fields_for, then __CHILD_INDEX__ will not be found, causing
  // this regex to be skipped over and allowing the passed in ID to be used
  add(event) {
    event.preventDefault();
    event.currentTarget.insertAdjacentHTML(
        'beforebegin',
        this.templateTarget.innerHTML.replace(
            /__CHILD_INDEX__/g,
            new Date().getTime().toString()
        )
    );
  }

  remove = e => {
    const container = e.currentTarget.closest('.nested-fields') as HTMLElement,
        id = (container.querySelector('input.id') as HTMLInputElement)?.value,
        destroy = container.querySelector('input.destroy') as HTMLInputElement;
    if (!!id?.length) {
      destroy.value = '1';
      container.style.display = 'none';
    }
    else if (!!container) container.remove();
  }
}